import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {GetHealthSpecialtyDescriptionParams} from 'domain/usecases/private/booking-flow/health/get-health-specialty-description';
import {getHealthSpecialtyDescription} from '../../services/getHealthSpecialtyDescription';

export function useGetHealthSpecialtyDescriptionQuery(params: GetHealthSpecialtyDescriptionParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_SPECIALTY_DESCRIPTION, params],
		queryFn: ({signal}) => getHealthSpecialtyDescription({signal, ...params}),
		retry: 1,
	});
}
